module.exports = __webpack_public_path__ + "img/nocollect.0b062f27.png";